@if (maneuverForm) {
	<div [formGroup]="maneuverForm">
		<div class="ob-selection-section">
			<mat-accordion [multi]="true" class="ob-selection-accordion">
				@for (OB of TS1_OB_LIST; track OB; let i = $index) {
					<mat-expansion-panel
						class="mb-value mat-elevation-z0"
						[class.has-value]="hasValue(OB.title)"
						(opened)="panelOpenState = true"
						(closed)="panelOpenState = false"
						[expanded]="hasValue(OB.title)"
					>
						<mat-expansion-panel-header>
							<mat-panel-title>
								<div class="flex w-full grid-cols-2 flex-row items-center gap-4">
									<span class="title whitespace-nowrap"
										><span class="font-bold"> {{ OB.title }}</span>
										<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
										{{ OB.desc }}
									</span>
									<div class="w-full border-b border-b-black"></div>
								</div>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<!-- KNO -->
						@if (OB.title == "KNO") {
							<app-ob-container [obFormGroup]="KNO" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- PRO -->
						@if (OB.title == "PRO") {
							<app-ob-container [obFormGroup]="PRO" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- COM -->
						@if (OB.title == "COM") {
							<app-ob-container [obFormGroup]="COM" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- FPA -->
						@if (OB.title == "FPA") {
							<app-ob-container [obFormGroup]="FPA" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- FPM -->
						@if (OB.title == "FPM") {
							<app-ob-container [obFormGroup]="FPM" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- LTW -->
						@if (OB.title == "LTW") {
							<app-ob-container [obFormGroup]="LTW" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- PSD -->
						@if (OB.title == "PSD") {
							<app-ob-container [obFormGroup]="PSD" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- SAW -->
						@if (OB.title == "SAW") {
							<app-ob-container [obFormGroup]="SAW" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
						<!-- WLM -->
						@if (OB.title == "WLM") {
							<app-ob-container [obFormGroup]="WLM" [OB]="OB" [showButtons]="false"></app-ob-container>
						}
					</mat-expansion-panel>
				}
			</mat-accordion>
		</div>
	</div>
}
